import { useState, useEffect } from "react";
import { AdminRecord } from "../config/panelTableConfig";

export interface AdminStats {
  total: number;
  active: number;
  inactive: number;
}

export interface UseAdminStatisticsProps {
  adminList: AdminRecord[];
}

export interface UseAdminStatisticsReturn {
  adminStats: AdminStats;
  loadAdminStats: () => void;
}

export const useAdminStatistics = ({ adminList }: UseAdminStatisticsProps): UseAdminStatisticsReturn => {
  // 统计状态
  const [adminStats, setAdminStats] = useState<AdminStats>({
    total: 0,
    active: 0,
    inactive: 0,
  });

  // 加载统计信息
  const loadAdminStats = () => {
    const stats = {
      total: adminList.length,
      active: adminList.filter((admin) => admin.account_status === 1).length,
      inactive: adminList.filter((admin) => admin.account_status === 2).length,
    };
    setAdminStats(stats);
  };

  // 当管理员列表更新时重新计算统计信息
  useEffect(() => {
    loadAdminStats();
  }, [adminList]);

  return {
    adminStats,
    loadAdminStats,
  };
};
